<template>
    <layout>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="() => {}">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                                <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>

                    <!-- CAONTACT INFO -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="pt-3 font-weight-normal w-100 cursor-pointer" href="#contact" data-toggle="collapse" aria-expanded="false" aria-controls="#contact">
                                {{ $t(`${pageID}.contact.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="contact">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{ $t(`${pageID}.contact.address`) }}</label>
                                <div class="city-form-group" :class="{'is-invalid': fnHasError('contact_address') }">
                                    <ckeditor
                                        name="contact_address"
                                        v-model="form.contact.address"
                                        :disabled="readonlyFormItem"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig"
                                        v-validate="'min:3'">
                                    </ckeditor>
                                    <small v-if="fnFirstError('contact_address')" class="d-block invalid-feedback">{{ fnFirstError('contact_address') }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                autocomplete="one-time-code"
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-contact_phone"
                                name="contact_phone"
                                v-model.trim="form.contact.phone"
                                v-validate="'min:9'"
                                :inputClasses="[{'is-invalid': fnHasError('contact_phone') }]"
                                :error=" fnFirstError('contact_phone')">
                                {{ $t(`${pageID}.contact.phone`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                autocomplete="one-time-code"
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="email"
                                class="city-form-group city-bg"
                                id="input-contact_email"
                                name="contact_email"
                                v-model.trim="form.contact.email"
                                v-validate="'email'"
                                :inputClasses="[{'is-invalid': fnHasError('contact_email') }]"
                                :error=" fnFirstError('contact_email')">
                                {{ $t(`${pageID}.contact.email`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-4">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-contact_coordinates"
                                name="contact_coordinates"
                                v-model.trim="form.contact.coordinates"
                                v-validate="'latLng'"
                                :placeholder="$t(`${pageID}.contact.coordinates_placeholder`)"
                                :inputClasses="[{'is-invalid': fnHasError('contact_coordinates') }]"
                                :error=" fnFirstError('contact_coordinates')">
                                {{ $t(`${pageID}.contact.coordinates`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-8">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-contact_coordinates_link"
                                name="contact_coordinates_link"
                                v-model.trim="form.contact.coordinates_link"
                                v-validate="{url: {require_protocol: true }}"
                                :inputClasses="[{'is-invalid': fnHasError('contact_coordinates_link') }]"
                                :error=" fnFirstError('contact_coordinates_link')">
                                {{ $t(`${pageID}.contact.coordinates_link`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <!-- GOOGLE APIS -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="pt-3 font-weight-normal w-100 cursor-pointer" href="#google" data-toggle="collapse" aria-expanded="false" aria-controls="#google">
                                {{ $t(`${pageID}.google.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="google">
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-google_g_maps_api"
                                name="google_g_maps_api"
                                v-model.trim="form.google.g_maps_api.key"
                                v-validate="{'min':3}"
                                :inputClasses="[{'is-invalid':
                                fnHasError('google_g_maps_api') }]"
                                :error="fnFirstError('google_g_maps_api')"
                                :helpTruncate="false"
                                :helpText="`${pageID}.google.help.g_maps_api`">
                                {{ $t(`${pageID}.google.g_maps_api`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-google_g_analytics_api"
                                name="google_g_analytics_api"
                                v-model.trim="form.google.g_analytics_api.id"
                                v-validate="{'min':3}"
                                :inputClasses="[{'is-invalid':
                                fnHasError('google_g_analytics_api') }]"
                                :error="fnFirstError('google_g_analytics_api')"
                                :helpTruncate="false"
                                :helpText="`${pageID}.google.help.g_analytics_api`">
                                {{ $t(`${pageID}.google.g_analytics_api`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <!-- SOCIAL NETWORKS -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="pt-3 font-weight-normal w-100 cursor-pointer" href="#social-networks" data-toggle="collapse" aria-expanded="false" aria-controls="#social-networks">
                                {{ $t(`${pageID}.social_networks.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="social-networks">
                        <div class="col-sm-12">
                            <div class="city-form-group">
                                <table class="table table-sm table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="text-center font-regular">{{ $t(`${pageID}.social_networks.id`) }}</th>
                                            <th scope="col" class="text-center font-regular">{{ $t(`${pageID}.social_networks.url`) }}</th>
                                            <th scope="col" class="text-center actions d-print-none" v-if="!readonlyFormItem">
                                                <button type="button" class="btn btn-main btn-sm min-w-auto m-0" @click="addValueItem">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr :key="index" v-for="(item, index) in form.social_networks">
                                            <td>
                                                <MaterialSelect
                                                    :readonly="readonlyFormItem"
                                                    class="city-form-group city-bg city-bg-sm"
                                                    :id="`input-social_id_${index}`"
                                                    :name="`social_id_${index}`"
                                                    v-model.trim="item.id"
                                                    label="name"
                                                    :options="socialNetworks"
                                                    :reduce="option => option.id"
                                                    v-validate="'required'"
                                                    :inputClasses="[{'is-invalid': fnHasError(`social_id_${index}`) }]"
                                                    :error="fnFirstError(`social_id_${index}`)">
                                                    {{ $t(`${pageID}.social_networks.id`) }}

                                                    <template v-slot:selected-option="{ option, label }">
                                                        <div class="d-flex flex-row flex-nowrap align-items-center">
                                                            <i :class="['pr-2', option['icon']]"></i> {{ option[label] }}
                                                        </div>
                                                    </template>
                                                    <template v-slot:option="{ option, label }">
                                                        <div class="d-flex flex-row flex-nowrap align-items-center">
                                                            <i :class="['pr-2', option['icon']]"></i> {{ option[label] }}
                                                        </div>
                                                    </template>
                                                </MaterialSelect>
                                            </td>
                                            <td>
                                                <MaterialInput
                                                    :readonly="readonlyFormItem"
                                                    class="city-form-group city-bg city-bg-sm"
                                                    :id="`input-social_url_${index}`"
                                                    :name="`social_url_${index}`"
                                                    v-model.trim="item.url"
                                                    v-validate="{required: true, url: {require_protocol: true}}"
                                                    :inputClasses="[{'is-invalid': fnHasError(`social_url_${index}`) }]"
                                                    :error="fnFirstError(`social_url_${index}`)">
                                                    {{ $t(`${pageID}.social_networks.url`) }}
                                                </MaterialInput>
                                            </td>
                                            <td class="text-center d-print-none" v-if="!readonlyFormItem">
                                                <button type="button" class="btn btn-danger btn-sm min-w-auto" @click="removeValueItem(index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <input type="hidden" name="social_networks" v-model="form.social_networks" v-validate="''" />
                            </div>
                        </div>
                    </div>

                    <!-- REGISTER -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="pt-3 font-weight-normal w-100 cursor-pointer" href="#register" data-toggle="collapse" aria-expanded="false" aria-controls="#register">
                                {{ $t(`${pageID}.register.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="register">
                        <div class="col-sm-12 ml-3">
                            <h6 class="font-weight-normal">{{ $t(`${pageID}.register.nif.title`) }}</h6>
                            <hr class="mt-2" />
                            <div class="row">
                                <div class="col-auto align-self-center form-group">
                                    <div class="form-check city-form-check form-check-inline">
                                        <input
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            type="checkbox"
                                            id="input-nif_active"
                                            name="nif_active"
                                            v-model.trim="form.register.nif.active"
                                            :false-value="false"
                                            :true-value="true"
                                            v-validate="''"/>
                                        <label
                                            class="form-check-label h-auto"
                                            :for="`input-nif_active`">
                                            <div class="d-flex flex-column align-items-start">
                                                <strong> {{ $t(`${pageID}.register.nif.active`) }}</strong>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-auto align-self-center form-group">
                                    <div class="form-check city-form-check form-check-inline">
                                        <input
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            type="checkbox"
                                            id="input-nif_required"
                                            name="nif_required"
                                            v-model.trim="form.register.nif.required"
                                            :false-value="false"
                                            :true-value="true"
                                            v-validate="''"/>
                                        <label
                                            class="form-check-label h-auto"
                                            :for="`input-nif_required`">
                                            <div class="d-flex flex-column align-items-start">
                                                <strong> {{ $t(`${pageID}.register.nif.required`) }}</strong>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="beforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout>
</template>

<script>
import GeneralMixin from './../../mixin';
import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';

export default {
    mixins: [
        GeneralMixin,
        CkEditorConfigMixin
    ],
    data() {
        return {
            pageID: 'settings',
            toolbarType: 'basic',
            form: {
                contact: {
                    address: '',
                    phone: null,
                    email: null,
                    coordinates: null,
                    coordinates_link: null,
                },
                social_networks: [],
                google: {
                    g_analytics_api: {
                        id: null,
                        gtag: true
                    },
                    g_maps_api: {
                        key: null,
                        region: 'pt',
                        language: 'pt',
                        loadCn: false
                    }
                },
                register: {
                    nif: {
                        active: false,
                        required: false,
                        country_code: 'PT',
                    }
                },
            },
        }
    },
    mounted() {
        this.loadConfig()
        .then( res => {
        });
    },
    computed: {
        titleItem() {
            return this.configTitle + ' - ' + this.pageTitle;
        },
        readonlyFormItem() {
            return !this.canConfigEdit;
        },
        socialNetworks() {
            return [
                {id: 'facebook', name: 'Facebook', icon: 'fab fa-facebook', url: ''},
                {id: 'twitter', name: 'Twitter', icon: 'fab fa-twitter', url: ''},
                {id: 'instagram', name: 'Instagram', icon: 'fab fa-instagram', url: ''},
                {id: 'linkedin', name: 'LinkedIn', icon: 'fab fa-linkedin', url: ''},
                {id: 'youtube', name: 'YouTube', icon: 'fab fa-youtube', url: ''},
                {id: 'pinterest', name: 'Pinterest', icon: 'fab fa-pinterest', url: ''},
                {id: 'googleplus', name: 'Google +', icon: 'fab fa-google-plus', url: ''},
                {id: 'whatsapp', name: 'WhatsApp', icon: 'fab fa-whatsapp', url: ''},
                {id: 'skype', name: 'Skype', icon: 'fab fa-skype', url: ''},
            ]
        }
    },
    methods: {
        addValueItem: function() {
            if(!this.readonlyFormItem) {
                if(!this.form.social_networks) {
                    this.form.social_networks = [];
                }
                this.form.social_networks.push({id: null, url: null});
                this.setFieldDirty('social_networks');
            }
        },
        removeValueItem: function(index) {
            if(!this.readonlyFormItem) {
                this.form.social_networks.splice(index,1);
                this.setFieldDirty('social_networks');
            }
        },
        beforeSaveItem: function() {
            if(!this.readonlyFormItem) {
                this.saveItem(null, [], {}, true);
            }
        },
    },
}
</script>

<style>
.table.table-sm th {
    padding-top: 0.25rem;
}
.ck-editor .ck-content.ck-editor__editable {
    min-height: 150px;
    max-height: 150px;
}
</style>